import React from 'react'

function PasswordRule({ rule }) {
  const { name, valid } = rule

  return (
    <div className="u-flex u-flexAlignItemsCenter u-padding1gu">
      <div className="u-flex u-flexJustifyCenter" style={{ width: 20 }}>
        <i>
          {valid ? (
            <span
              aria-hidden="true"
              className="Icon u-textSizeMsrp2 u-textColorConfirm"
            >
              ✓
            </span>
          ) : (
            <span
              aria-hidden="true"
              className="Icon u-textSizeMsrp2 u-textColorAlert"
            >
              ✗
            </span>
          )}
          <span className="u-hiddenVisually">
            {valid ? 'Valid' : 'Invalid'}
          </span>
        </i>
      </div>
      <div className="u-marginLeft1gu">{name}</div>
    </div>
  )
}

PasswordRule.propTypes = {}

export default PasswordRule
